import { render, staticRenderFns } from "./FilialCard.vue?vue&type=template&id=361f4e63"
import script from "./FilialCard.vue?vue&type=script&lang=js"
export * from "./FilialCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports